export const POWERED_BY_DEGEN_LAYER =
  process.env.VUE_APP_POWERED_BY_DEGEN_LAYER === 'true' ?? false;
